module.exports = __webpack_public_path__ + "dimer/static/img/logo2.d8709c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/logo2.jpg
// module id = UIpq
// module chunks = 0